(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const viewToggle2 = document.getElementById('view_toggle_2');
    const viewToggle4 = document.getElementById('view_toggle_4');
    const viewToggle5 = document.getElementById('view_toggle_5');
    const collection = document.querySelector('.collection');
    const collectionItems = document.querySelector('.collection__items');

    let currentView = 4;

    if (collection) {
      if (window.innerWidth < 768) {
        collection.classList.add('collection--grid-2');
        if (viewToggle2) viewToggle2.classList.add('active');
        currentView = 2;
      } else {
        collection.classList.add('collection--grid-4');
        if (viewToggle4) viewToggle4.classList.add('active');
        currentView = 4;
      }
    }

    function updateGridView(gridSize) {
      collection.classList.remove('collection--grid-2', 'collection--grid-4', 'collection--grid-5');

      if (viewToggle2) viewToggle2.classList.remove('active');
      if (viewToggle4) viewToggle4.classList.remove('active');
      if (viewToggle5) viewToggle5.classList.remove('active');

      collection.classList.add(`collection--grid-${gridSize}`);

      if (gridSize === 2 && viewToggle2) {
        viewToggle2.classList.add('active');
      } else if (gridSize === 4 && viewToggle4) {
        viewToggle4.classList.add('active');
      } else if (gridSize === 5 && viewToggle5) {
        viewToggle5.classList.add('active');
      }

      currentView = gridSize;
    }

    if (viewToggle2) {
      viewToggle2.addEventListener('click', function () {
        updateGridView(2);
      });
    }

    if (viewToggle4) {
      viewToggle4.addEventListener('click', function () {
        updateGridView(4);
      });
    }

    if (viewToggle5) {
      viewToggle5.addEventListener('click', function () {
        updateGridView(5);
      });
    }

    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        if (window.innerWidth < 768 && currentView === 5) {
          updateGridView(2);
        } else if (window.innerWidth >= 768 && currentView === 2) {
          updateGridView(4);
        }
      }, 250);
    });

    const description = document.getElementById('collection-description');
    const descriptionToggle = document.getElementById('collection-description-toggle');

    if (description && descriptionToggle) {
      // Show the toggle only if the collapsed text is actually cut off
      if (
        description.scrollHeight > description.clientHeight ||
        description.scrollWidth > description.clientWidth
      ) {
        descriptionToggle.hidden = false;
      } else {
        description.classList.remove('is-collapsed');
      }

      descriptionToggle.addEventListener('click', function () {
        const isCollapsed = description.classList.toggle('is-collapsed');
        descriptionToggle.setAttribute('aria-expanded', String(!isCollapsed));
        descriptionToggle.textContent = isCollapsed
          ? descriptionToggle.dataset.labelMore
          : descriptionToggle.dataset.labelLess;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const viewToggle2 = document.getElementById('view_toggle_2');
    const viewToggle4 = document.getElementById('view_toggle_4');
    const viewToggle5 = document.getElementById('view_toggle_5');
    const collection = document.querySelector('.collection');
    const collectionItems = document.querySelector('.collection__items');

    let currentView = 4;

    if (collection) {
      if (window.innerWidth < 768) {
        collection.classList.add('collection--grid-2');
        if (viewToggle2) viewToggle2.classList.add('active');
        currentView = 2;
      } else {
        collection.classList.add('collection--grid-4');
        if (viewToggle4) viewToggle4.classList.add('active');
        currentView = 4;
      }
    }

    function updateGridView(gridSize) {
      collection.classList.remove('collection--grid-2', 'collection--grid-4', 'collection--grid-5');

      if (viewToggle2) viewToggle2.classList.remove('active');
      if (viewToggle4) viewToggle4.classList.remove('active');
      if (viewToggle5) viewToggle5.classList.remove('active');

      collection.classList.add(`collection--grid-${gridSize}`);

      if (gridSize === 2 && viewToggle2) {
        viewToggle2.classList.add('active');
      } else if (gridSize === 4 && viewToggle4) {
        viewToggle4.classList.add('active');
      } else if (gridSize === 5 && viewToggle5) {
        viewToggle5.classList.add('active');
      }

      currentView = gridSize;
    }

    if (viewToggle2) {
      viewToggle2.addEventListener('click', function () {
        updateGridView(2);
      });
    }

    if (viewToggle4) {
      viewToggle4.addEventListener('click', function () {
        updateGridView(4);
      });
    }

    if (viewToggle5) {
      viewToggle5.addEventListener('click', function () {
        updateGridView(5);
      });
    }

    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        if (window.innerWidth < 768 && currentView === 5) {
          updateGridView(2);
        } else if (window.innerWidth >= 768 && currentView === 2) {
          updateGridView(4);
        }
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
